import type { CreditAppState } from '@makemydeal/dr-sales-checkin-store';

export const initialCreditAppState: CreditAppState = {
    status: null,
    creditAppId: null,
    dealRefId: null,
    shopper: null
};
